export const PROMPTS = [
  "What can you do?",
  "Do Amazon ad campaigns run continuously, or do they stop at certain hours?",
  "How long does it take for an Amazon PPC campaign to start showing results?",
  "What measures does Amazon take to ensure reviews are genuine and trustworthy?",
  "Simple steps to review your video recommendations?",
];
